<template>
  <div>
    <header class="header">
      <div class="header__content">
        <h2 class="header__title">
          {{ $t("message.storeLocator.faq.toLocation") }}:
        </h2>
      </div>
    </header>
    <CompanyCard
      v-if="selectedFacility"
      class="ml-5"
      :name="selectedFacility.name"
      :address="selectedFacility.formatted_address"
      :store-code="selectedFacility.store_code"
    />
    <v-form ref="form">
      <div class="content">
        <v-textarea
          v-model="form.question"
          name="question"
          :label="$t('message.storeLocator.faq.question')"
          v-validate="'required|max-length:200|min-length:10|min-words:3'"
          rows="2"
          counter="200"
          no-resize
          :error-messages="errors.collect('question')"
        ></v-textarea>
        <v-textarea
          v-model="form.answer"
          name="answer"
          :label="$t('message.storeLocator.faq.answer')"
          rows="3"
          v-validate="'required|max-length:500'"
          counter="500"
          no-resize
          :error-messages="errors.collect('answer')"
        ></v-textarea>
      </div>
    </v-form>
    <InfoBox
      class="mt-6"
      :text="$t('message.questionsAndAnswers.sharingPubliclyOnGoogle')"
    />
    <div class="action-bar">
      <ui-button color="primary" outlined @click="handleBack">
        {{ $t("message.common.back") }}
      </ui-button>
      <ui-button color="primary" @click="handleSubmit">
        {{ $t("message.questionsAndAnswers.publishAnswer") }}
      </ui-button>
    </div>
  </div>
</template>

<script>
import CompanyCard from "@/components/BusinessAddresses/StoreLocatorCompanyCard.vue";
import InfoBox from "@/components/ui/InfoBox.vue";

export default {
  name: "QaManageDialogQuestionView",
  components: {
    CompanyCard,
    InfoBox
  },
  props: {
    selectedFacility: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        question: "",
        answer: ""
      }
    };
  },
  methods: {
    handleSubmit() {
      this.$validator.validateAll().then(success => {
        if (!success) {
          return;
        }
        this.$emit("submit", {
          formData: this.form,
          facility: this.selectedFacility.id
        });
      });
    },
    handleBack() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep label,
::v-deep textarea {
  @include font-size(14px);
}
.action-bar {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  padding: 24px 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: $spacing * 3;
  position: relative;
  padding-left: $spacing * 2.5;
  height: 32px;
  margin-bottom: $spacing;

  &__title {
    font-family: "Montserrat", sans-serif;
    @include font-size(16px);
    font-weight: 500;
    line-height: 1em;
  }

  &:before {
    position: absolute;
    content: "";
    display: block;
    width: 3px;
    height: 32px;
    background-color: $lime;
    left: 0;
    border-radius: 8px;
  }
}
</style>
